import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ReceivedNotReviewed = ({ t, i18n }) => {
  const navigate = useNavigate();
  const language = i18n.language;

  const datesData = useSelector((state) => state.datesReducer);
  let currentLanguageDates;
  if (datesData) {
    currentLanguageDates = datesData[i18n.language];
  }

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "We’ve received your application but it hasn’t been reviewed yet - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Nous avons reçu votre demande, mais elle n’a pas encore été traitée – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);
  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <div className="row">
                    <div className="col-xs-12 col-lg-12">
                      <h2 style={{ marginBottom: 0 }}>
                        {t("application_status.not_reviewed_title")}
                      </h2>
                      <br />
                      <span>
                        {t("application_status.not_reviewed_2").replace(
                          "#YEAR",
                          currentLanguageDates?.taxFiled
                        )}
                      </span>
                      <br />
                      <br />
                      <span>{t("application_status.not_reviewed_3")}</span>
                      <br />
                      <br />
                      <span>{t("application_status.cra_notifies")} </span>
                      <Link
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(
                            `/${i18n.language}${t("routes.check_status")}`
                          )
                        }
                      >
                        {t("application_status.check_status_link")}
                      </Link>
                      <span>{t("application_status.at_any_time")} </span>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 ">
                      <h3>
                        {t("application_status.recently_tax_filed").replace(
                          "#YEAR",
                          currentLanguageDates?.taxFiled
                        )}
                      </h3>
                      {t("application_status.allow_cra_to_process").replace(
                        "#YEAR",
                        currentLanguageDates?.taxFiled
                      )}
                      <br />
                      <br />
                      {language === "en" ? (
                        <Link
                          href="https://www.canada.ca/en/revenue-agency/corporate/contact-information/check-cra-processing-times.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ cursor: "pointer" }}
                        >
                          {t("application_status.CRA_processing_times")}
                        </Link>
                      ) : (
                        <Link
                          href="https://www.canada.ca/fr/agence-revenu/organisation/coordonnees/verifier-delais-traitement-arc.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ cursor: "pointer" }}
                        >
                          {t("application_status.CRA_processing_times")}
                        </Link>
                      )}
                    </div>
                  </div>

                  {/* <div className="row">
                    <div className="col-xs-12">
                      <h3>{t("confirmation.will_we_contact")}</h3>
                      {t("confirmation.will_we_contact_note")}
                      <span>{currentLanguageDates?.receiptDate}</span>
                      <span>{t("confirmation.will_we_contact_note_1")}</span>
                      <br />
                      <br />
                      {t("confirmation.will_we_contact_note_2")}
                    </div>
                  </div> */}

                  <div className="row">
                    <div className="col-xs-12">
                      <h3>{t("otherGrantQuestions.questions")}</h3>
                      <h5>{t("otherGrantQuestions.contact")}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(ReceivedNotReviewed);
